@if (stakingAmountUIModel$ | async; as model) {
  <div class="amount-input">
    <input
      numbersOnly
      limitDecimalToCurrency
      [displayTradable]="model.displayTradable"
      [ngModel]="model.value | local_format: model.displayTradable"
      (ngModelChange)="valueChange($event, model)"
      [min]="0"
      [max]="model | staking_amount_selector_available_to_stake"
      required
      autofocus
      [tabIndex]="0"
      class="bp-form-field" />
    <div
      class="exchange"
      [tabIndex]="0"
      (click)="triggerExchange(model)"
      (keydown.enter)="$event.stopPropagation(); triggerExchange(model)">
      <span
					[ngClass]="{
						'text-highlight': model.displayTradable
					}">
        {{ model.tradable ? (model.tradable | access_tradable_symbol) : "" }}
      </span>
      /
      <span
					[ngClass]="{
						'text-highlight': !model.displayTradable
					}">
        {{ model.defaultFiat ? (model.defaultFiat | access_fiat_symbol) : "" }}
      </span>
    </div>
  </div>
  <div class="available">
    {{
    (model.stakingType === stakingTypes.STAKE ? "staking_available_to_stake" : "available_to_unstake")
    | translate
    : [
    model.displayTradable
    ? (model
    | staking_amount_selector_available_to_stake
    | tradable_precision_symbol
    : { id: model.tradable?.getId(), ignorePrecision: true })
    : (model
    | staking_amount_selector_available_to_stake
    | fiat_precision_symbol
    : {
    id: model.defaultFiat?.getId(),
    currencies: model.defaultFiat ? [model.defaultFiat] : []
    })
    ]
    }}
    @if (model.displayTradable) {
      <span class="available-converted-fiat">
        ≈
        {{
        model.stakingType === stakingTypes.STAKE
        ? (model.walletBalanceInTradable
        | convert_tradable_to_fiat: model.tradable?.getId()
        | fiat_precision_symbol
        : { id: model.defaultFiat?.getId(), currencies: model.defaultFiat ? [model.defaultFiat] : [] })
        : (model.stakedAmountInTradable
        | convert_tradable_to_fiat: model.tradable?.getId()
        | fiat_precision_symbol
        : { id: model.defaultFiat?.getId(), currencies: model.defaultFiat ? [model.defaultFiat] : [] })
        }}
      </span>
    } @else {
      <span class="available-converted-fiat">
        ≈
        {{
        model.stakingType === stakingTypes.STAKE
        ? (model.walletBalanceInTradable | tradable_precision_symbol: { id: model.tradable?.getId() })
        : (model.stakedAmountInTradable | tradable_precision_symbol: { id: model.tradable?.getId() })
        }}
      </span>
    }
  </div>
  <div class="options">
    @for (percentage of model.options; track percentage; let index = $index; let first = $first; let last = $last) {
      <div
        bpArrowNav
        class="option"
        [first]="first"
        [last]="last"
        [ngClass]="{ selected: index === model.selectedPercentage && manualPercentSelected }"
        [tabIndex]="0"
        (click)="setPercentage(index, model, true)"
        (keydown.enter)="$event.stopPropagation(); setPercentage(index, model, true)"
        >
        {{ percentage | percent_symbol }}
      </div>
    }
  </div>
  @if (hasMultipleWallets) {
    <div class="wallet-info">
      <span class="bpi__icon-info mr-10"></span>
      <span class="text-small-black">{{ "staking_wallet_default_only" | translate }}</span>
    </div>
  }
  <!-- Performance indicator needed for UK -->
	<div class="mt-40 font-size-13 text-gray">
		{{ "performance_indicators_7_days_timeframe" | translate }}
	</div>
}
